export default {
  DOMPurifyConfig: {
    ADD_ATTR: ['onClick', 'onLoad'],
    ADD_TAGS: ['el-button', 'el-row', 'el-col', 'style'],
    ALLOWED_TAGS: ['style', 'div', 'img', 'b', 'q', 'ul', 'li', 'span', 'p']
  }
}
